import React from "react";

import { Popup } from "semantic-ui-react";

import styles from "./UserBadges.module.css";

export const Pending = () => (
	<Popup
		inverted
		size="tiny"
		content="An invite has already been sent to join Fellow."
		position="bottom center"
		trigger={<span className={styles.pending}>Pending</span>}
		className={styles.popup}
	/>
);
export const Inactive = () => <span className={styles.inactive}>Inactive</span>;
export const NotInvited = () => (
	<Popup
		inverted
		size="tiny"
		content="An invite to join Fellow has not been sent yet."
		position="bottom center"
		trigger={<span className={styles.notInvited}>Not invited</span>}
		className={styles.popup}
	/>
);

export function autoBadge(user: { isActive: boolean; isConfigured: boolean; hasReceivedInvites: boolean }) {
	if (user.isActive) {
		if (user.isConfigured) {
			return null;
		} else if (user.hasReceivedInvites) {
			return Pending();
		} else {
			return NotInvited();
		}
	} else {
		return Inactive();
	}
}
